<template>
  <div
    class="bg-gray-100 py-6"
    style="height: calc(100vh - 70px); width: 100%; min-width: 700px"
  >
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <!-- Header -->
      <div class="mb-6">
        <div class="flex items-center justify-between">
          <div>
            <h1 class="text-2xl font-bold text-gray-900">
              {{ isEditing ? "Edit Upsell" : "Create Upsell" }}
            </h1>
            <p class="mt-2 text-sm text-gray-600">
              {{
                isEditing
                  ? "Update your upsell campaign settings"
                  : "Create a new upsell campaign to boost revenue"
              }}
            </p>
          </div>
          <button
            type="button"
            class="inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            @click="goBack"
          >
            <svg
              class="-ml-1 mr-2 h-5 w-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M10 19l-7-7m0 0l7-7m-7 7h18"
              ></path>
            </svg>
            Back to Upsells
          </button>
        </div>
      </div>

      <!-- Two Column Layout -->
      <div
        class="Polaris-InlineGrid"
        style="
          --pc-inline-grid-grid-template-columns-xs: minmax(0, 1fr);
          --pc-inline-grid-grid-template-columns-md: minmax(0, 2fr) minmax(0, 1fr);
          --pc-inline-grid-gap-xs: var(--p-space-400);
        "
      >
        <!-- Left column: Configuration Form -->
        <div style="display: inherit; width: auto; border-inline-start: none">
          <div
            class="Polaris-InlineStack"
            style="
              --pc-inline-stack-align: center;
              --pc-inline-stack-wrap: wrap;
              --pc-inline-stack-gap-xs: var(--p-space-400);
              --pc-inline-stack-flex-direction-xs: row;
            "
          >
            <div
              style="color: var(--p-color-text-info-on-bg-fill); width: 100%"
            >
              <div class="Polaris-LegacyCard">
                <!-- Upsell Details Section -->
                <div class="Polaris-LegacyCard__Section">
                  <div
                    class="Polaris-LegacyStack Polaris-LegacyStack--alignmentCenter"
                  >
                    <div
                      class="Polaris-LegacyStack__Item Polaris-LegacyStack__Item--fill"
                    >
                      <h2 class="Polaris-Text--root Polaris-Text--headingMd">
                        Upsell Details
                      </h2>
                      <p class="mt-1 text-sm leading-5 text-gray-500">
                        Configure your upsell campaign settings
                      </p>
                    </div>
                  </div>
                </div>

                <!-- Campaign Name Section -->
                <div
                  class="Polaris-LegacyCard__Section border-b border-gray-200"
                >
                  <div
                    class="Polaris-BlockStack"
                    style="
                      --pc-block-stack-order: column;
                      --pc-block-stack-gap-xs: var(--p-space-400);
                    "
                  >
                    <div
                      class="Polaris-BlockStack"
                      style="
                        --pc-block-stack-order: column;
                        --pc-block-stack-gap-xs: var(--p-space-200);
                      "
                      role="group"
                    >
                      <div class="Polaris-FormLayout__Item">
                        <div class="Polaris-Labelled__LabelWrapper">
                          <div class="Polaris-Label">
                            <label class="Polaris-Label__Text"
                              >Upsell Name</label
                            >
                          </div>
                        </div>
                        <div class="Polaris-Connected">
                          <div
                            class="Polaris-Connected__Item Polaris-Connected__Item--primary"
                          >
                            <div class="Polaris-TextField">
                              <input
                                class="Polaris-TextField__Input"
                                type="text"
                                v-model="form.name"
                                ref="name"
                                placeholder="Upsell name"
                              />
                              <div class="Polaris-TextField__Backdrop"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Trigger Section -->
                <div
                  class="Polaris-LegacyCard__Section border-b border-gray-200"
                >
                  <div
                    class="Polaris-BlockStack"
                    style="
                      --pc-block-stack-order: column;
                      --pc-block-stack-gap-xs: var(--p-space-400);
                    "
                  >
                    <div
                      class="Polaris-BlockStack"
                      style="
                        --pc-block-stack-order: column;
                        --pc-block-stack-gap-xs: var(--p-space-200);
                      "
                      role="group"
                    >
                      <div class="Polaris-FormLayout__Item">
                        <div class="Polaris-Labelled__LabelWrapper">
                          <div class="Polaris-Label">
                            <label class="Polaris-Label__Text"
                              >When to send the message</label
                            >
                          </div>
                        </div>
                        <div class="Polaris-Connected">
                          <div
                            class="Polaris-Connected__Item Polaris-Connected__Item--primary"
                          >
                            <div class="Polaris-TextField">
                              <input
                                id="sendAfterDays"
                                type="number"
                                class="Polaris-TextField__Input"
                                placeholder="number between 1 - 70"
                                aria-labelledby="sendAfterDaysLabel"
                                v-model.number="form.sendAfterDays"
                                aria-invalid="false"
                              />
                              <div class="Polaris-TextField__Backdrop"></div>
                            </div>
                          </div>
                          <div class="Polaris-Connected__Item">
                            <div class="Polaris-Labelled--hidden">
                              <div class="Polaris-Labelled__LabelWrapper">
                                <div class="Polaris-Label">
                                  <label
                                    id="sendAfterLabel"
                                    for="sendAfter"
                                    class="Polaris-Label__Text"
                                  >
                                    <span
                                      class="Polaris-Text--root Polaris-Text--bodyMd"
                                      >Send after type</span
                                    >
                                  </label>
                                </div>
                              </div>
                              <div class="Polaris-Select">
                                <select
                                  id="sendAfter"
                                  class="Polaris-Select__Input"
                                  v-model="form.sendAfter"
                                  aria-invalid="false"
                                >
                                  <option value="order_created">
                                    days after order created
                                  </option>
                                  <option value="order_fulfilled">
                                    days after order fulfilled
                                  </option>
                                  <option value="order_delivered">
                                    days after order delivered
                                  </option>
                                </select>
                                <div
                                  class="Polaris-Select__Content"
                                  aria-hidden="true"
                                >
                                  <span
                                    class="Polaris-Select__SelectedOption"
                                    >{{
                                      form.sendAfter === "order_created"
                                        ? "days after order created"
                                        : form.sendAfter === "order_fulfilled"
                                        ? "days after order fulfilled"
                                        : "days after order delivered"
                                    }}</span
                                  >
                                  <span class="Polaris-Select__Icon">
                                    <span class="Polaris-Icon">
                                      <svg
                                        viewBox="0 0 20 20"
                                        class="Polaris-Icon__Svg"
                                        focusable="false"
                                        aria-hidden="true"
                                      >
                                        <path
                                          d="M10.884 4.323a1.25 1.25 0 0 0-1.768 0l-2.646 2.647a.75.75 0 0 0 1.06 1.06l2.47-2.47 2.47 2.47a.75.75 0 1 0 1.06-1.06l-2.646-2.647Z"
                                        ></path>
                                        <path
                                          d="m13.53 13.03-2.646 2.647a1.25 1.25 0 0 1-1.768 0l-2.646-2.647a.75.75 0 0 1 1.06-1.06l2.47 2.47 2.47-2.47a.75.75 0 0 1 1.06 1.06Z"
                                        ></path>
                                      </svg>
                                    </span>
                                  </span>
                                </div>
                                <div class="Polaris-Select__Backdrop"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Cancel Trigger Section -->
                <div
                  class="Polaris-LegacyCard__Section border-b border-gray-200"
                >
                  <div
                    class="Polaris-BlockStack"
                    style="
                      --pc-block-stack-order: column;
                      --pc-block-stack-gap-xs: var(--p-space-400);
                    "
                  >
                    <div
                      class="Polaris-BlockStack"
                      style="
                        --pc-block-stack-order: column;
                        --pc-block-stack-gap-xs: var(--p-space-200);
                      "
                      role="group"
                    >
                      <div class="Polaris-FormLayout__Item">
                        <label
                          class="Polaris-Choice Polaris-Checkbox__ChoiceLabel"
                          for="shouldCheckForDaysWithoutPurchase"
                        >
                          <span class="Polaris-Choice__Control">
                            <span class="Polaris-Checkbox">
                              <input
                                id="shouldCheckForDaysWithoutPurchase"
                                type="checkbox"
                                class="Polaris-Checkbox__Input"
                                aria-invalid="false"
                                role="checkbox"
                                :aria-checked="
                                  form.conditions
                                    .shouldCheckForDaysWithoutPurchase
                                    ? 'true'
                                    : 'false'
                                "
                                v-model="
                                  form.conditions
                                    .shouldCheckForDaysWithoutPurchase
                                "
                                value=""
                              />
                              <span class="Polaris-Checkbox__Backdrop"></span>
                              <span class="Polaris-Checkbox__Icon">
                                <svg
                                  viewBox="0 0 20 20"
                                  class="Polaris-Icon__Svg"
                                  focusable="false"
                                  aria-hidden="true"
                                >
                                  <path
                                    d="M8.315 13.859l-3.182-3.417a.506.506 0 0 1 0-.684l.643-.683a.437.437 0 0 1 .642 0l2.22 2.393 4.942-5.327a.436.436 0 0 1 .643 0l.643.684a.504.504 0 0 1 0 .683l-5.91 6.35a.437.437 0 0 1-.642 0"
                                  ></path>
                                </svg>
                              </span>
                            </span>
                          </span>
                          <span class="Polaris-Choice__Label">
                            <span
                              class="Polaris-Text--root Polaris-Text--bodyMd"
                              >Send Only if the customer didn't places an order
                              in X days</span
                            >
                          </span>
                        </label>

                        <div
                          class="Polaris-Connected"
                          v-if="
                            form.conditions.shouldCheckForDaysWithoutPurchase
                          "
                        >
                          <div
                            class="Polaris-Connected__Item Polaris-Connected__Item--primary"
                          >
                            <div class="Polaris-TextField">
                              <input
                                id="sendAfterDays"
                                type="number"
                                class="Polaris-TextField__Input"
                                placeholder="number between 1 - 70"
                                aria-labelledby="sendAfterDaysLabel"
                                v-model.number="
                                  form.conditions.daysWithoutPurchase
                                "
                                aria-invalid="false"
                              />
                              <div
                                class="Polaris-TextField__Suffix"
                                id=":Rq6:-Suffix"
                              >
                                <span
                                  class="Polaris-Text--root Polaris-Text--bodyMd"
                                  >Days</span
                                >
                              </div>
                              <div class="Polaris-TextField__Backdrop"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Condition Selector Section -->
                <div
                  class="Polaris-LegacyCard__Section border-b border-gray-200"
                >
                  <div
                    class="Polaris-BlockStack"
                    style="
                      --pc-block-stack-order: column;
                      --pc-block-stack-gap-xs: var(--p-space-400);
                    "
                  >
                    <div
                      class="Polaris-BlockStack"
                      style="
                        --pc-block-stack-order: column;
                        --pc-block-stack-gap-xs: var(--p-space-200);
                      "
                      role="group"
                    >
                      <div class="Polaris-FormLayout__Item">
                        <div class="Polaris-Labelled__LabelWrapper">
                          <div class="Polaris-Label">
                            <label class="Polaris-Label__Text"
                              >When customer orders</label
                            >
                          </div>
                        </div>
                        <div class="Polaris-LegacyCard">
                          <div
                            class="Polaris-LegacyCard__Section Polaris-LegacyCard__LastSectionPadding"
                          >
                            <div
                              class="Polaris-LegacyStack Polaris-LegacyStack--vertical"
                            >
                              <div class="Polaris-LegacyStack__Item">
                                <div>
                                  <label
                                    class="Polaris-Choice Polaris-RadioButton__ChoiceLabel"
                                    for="all"
                                  >
                                    <span class="Polaris-Choice__Control">
                                      <span class="Polaris-RadioButton">
                                        <input
                                          id="all"
                                          name="applicability"
                                          type="radio"
                                          class="Polaris-RadioButton__Input"
                                          value="all"
                                          v-model="form.appliesTo"
                                        />
                                        <span
                                          class="Polaris-RadioButton__Backdrop"
                                        ></span>
                                      </span>
                                    </span>
                                    <span class="Polaris-Choice__Label">
                                      <span
                                        class="Polaris-Text--root Polaris-Text--bodyMd"
                                        >Any products</span
                                      >
                                    </span>
                                  </label>
                                  <div class="Polaris-Choice__Descriptions">
                                    <div class="Polaris-Choice__HelpText">
                                      <span
                                        class="Polaris-Text--root Polaris-Text--subdued"
                                        >Upsell will be sent for all
                                        orders</span
                                      >
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="Polaris-LegacyStack__Item">
                                <div>
                                  <label
                                    class="Polaris-Choice Polaris-RadioButton__ChoiceLabel"
                                    for="specific-products"
                                  >
                                    <span class="Polaris-Choice__Control">
                                      <span class="Polaris-RadioButton">
                                        <input
                                          id="specific-products"
                                          name="applicability"
                                          type="radio"
                                          class="Polaris-RadioButton__Input"
                                          value="specific-products"
                                          v-model="form.appliesTo"
                                        />
                                        <span
                                          class="Polaris-RadioButton__Backdrop"
                                        ></span>
                                      </span>
                                    </span>
                                    <span class="Polaris-Choice__Label">
                                      <span
                                        class="Polaris-Text--root Polaris-Text--bodyMd"
                                        >Specific products</span
                                      >
                                    </span>
                                  </label>
                                  <div class="Polaris-Choice__Descriptions">
                                    <div class="Polaris-Choice__HelpText">
                                      <span
                                        class="Polaris-Text--root Polaris-Text--subdued"
                                        >Upsell will only be sent for selected
                                        products</span
                                      >
                                    </div>
                                    <div
                                      v-if="
                                        form.appliesTo === 'specific-products'
                                      "
                                      class="mt-4"
                                    >
                                      <button
                                        class="Polaris-Button Polaris-Button--pressable Polaris-Button--variantSecondary Polaris-Button--sizeMedium Polaris-Button--textAlignCenter"
                                        type="button"
                                        @click="openProductPicker"
                                      >
                                        <span
                                          class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--medium"
                                          >Add product</span
                                        >
                                      </button>
                                      <div
                                        v-if="form.conditions.products.length"
                                      >
                                        <div class="mt-3 space-y-2">
                                          <div
                                            v-for="product in form.conditions
                                              .products"
                                            :key="product.id"
                                            class="flex items-center justify-between bg-gray-50 rounded-lg px-3 py-2 border border-gray-200"
                                          >
                                            <span
                                              class="text-sm font-medium text-gray-900"
                                            >
                                              {{ product.title || product.id }}
                                            </span>
                                            <button
                                              type="button"
                                              class="text-gray-400 hover:text-red-500 transition-colors"
                                              @click="removeProduct(product.id)"
                                            >
                                              <svg
                                                class="w-4 h-4"
                                                fill="none"
                                                stroke="currentColor"
                                                viewBox="0 0 24 24"
                                              >
                                                <path
                                                  stroke-linecap="round"
                                                  stroke-linejoin="round"
                                                  stroke-width="2"
                                                  d="M6 18L18 6M6 6l12 12"
                                                ></path>
                                              </svg>
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Template Selection Section -->
                <div
                  class="Polaris-LegacyCard__Section border-b border-gray-200"
                >
                  <div
                    class="Polaris-BlockStack"
                    style="
                      --pc-block-stack-order: column;
                      --pc-block-stack-gap-xs: var(--p-space-400);
                    "
                  >
                    <div
                      class="Polaris-BlockStack"
                      style="
                        --pc-block-stack-order: column;
                        --pc-block-stack-gap-xs: var(--p-space-200);
                      "
                      role="group"
                    >
                      <div class="Polaris-FormLayout__Item">
                        <div class="Polaris-Labelled__LabelWrapper">
                          <div class="Polaris-Label">
                            <label class="Polaris-Label__Text"
                              >Message Template
                              <button
                                v-if="isEditing"
                                class="Polaris-Button Polaris-Button--plain"
                                @click="customizeMessage('upsell')"
                              >
                                <a class="Polaris-Link"
                                  >Customize the message?</a
                                >
                              </button>
                            </label>
                          </div>
                        </div>
                        <div class="Polaris-Connected">
                          <AutomationVariableDropdown
                            :templateType="'upsell'"
                            @onItemClicked="insertAtCursor"
                            style="
                              position: absolute;
                              z-index: 1000;
                              right: 0;
                              top: -30px;
                            "
                          />
                          <div
                            class="Polaris-Connected__Item Polaris-Connected__Item--primary mt-5"
                          >
                            <div class="Polaris-TextField">
                              <textarea
                                ref="content"
                                class="Polaris-TextField__Input"
                                v-model="form.message"
                                :disabled="isEditing"
                                required
                                rows="4"
                                placeholder="Enter your message template..."
                              ></textarea>
                              <div class="Polaris-TextField__Backdrop"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="Polaris-LegacyCard__Section border-b border-gray-200"
                >
                  <div
                    class="Polaris-BlockStack"
                    style="
                      --pc-block-stack-order: column;
                      --pc-block-stack-gap-xs: var(--p-space-400);
                    "
                  >
                    <div
                      class="Polaris-BlockStack"
                      style="
                        --pc-block-stack-order: column;
                        --pc-block-stack-gap-xs: var(--p-space-200);
                      "
                      role="group"
                    >
                      <div class="Polaris-FormLayout__Item">
                        <div class="Polaris-Labelled__LabelWrapper">
                          <div class="Polaris-Label">
                            <label class="Polaris-Label__Text"
                              >Image (Optional)</label
                            >
                          </div>
                        </div>
                        <div class="Polaris-Connected">
                          <div
                            class="Polaris-Connected__Item Polaris-Connected__Item--primary"
                          >
                            <div class="Polaris-TextField">
                              <input
                                class="Polaris-TextField__Input"
                                type="file"
                                accept="image/*"
                                @change="uploadFile"
                                ref="imageInput"
                              />
                              <div class="Polaris-TextField__Backdrop"></div>
                            </div>
                          </div>
                        </div>
                        <p class="mt-2 text-sm text-gray-500">
                          Upload an image to include in your message (JPG, PNG,
                          GIF)
                        </p>
                        <!-- Image Preview -->
                        <div
                          v-if="form.imageFile || form.imageUrl"
                          class="mt-3"
                        >
                          <div class="relative inline-block">
                            <img
                              :src="form.imageUrl || form.imagePreview"
                              alt="Uploaded image"
                              class="w-32 h-24 object-cover rounded-lg border"
                              @error="handleImageError"
                            />
                            <button
                              type="button"
                              @click="removeImage"
                              style="top: 1px; right: -36px"
                              class="absolute bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs hover:bg-red-600"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                class="h-4 w-4"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                              >
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-width="2"
                                  d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
                                />
                              </svg>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class="Polaris-LegacyCard__Section border-b border-gray-200"
                >
                  <div
                    class="Polaris-BlockStack"
                    style="
                      --pc-block-stack-order: column;
                      --pc-block-stack-gap-xs: var(--p-space-400);
                    "
                  >
                    <div
                      class="Polaris-BlockStack"
                      style="
                        --pc-block-stack-order: column;
                        --pc-block-stack-gap-xs: var(--p-space-200);
                      "
                      role="group"
                    >
                      <!-- Button Configuration Section -->
                      <div class="Polaris-FormLayout__Item">
                        <div class="Polaris-Labelled__LabelWrapper">
                          <div class="Polaris-Label">
                            <label class="Polaris-Label__Text"
                              >Call-to-Action Button (Optional)</label
                            >
                          </div>
                        </div>
                        <div class="Polaris-Connected">
                          <div
                            class="Polaris-Connected__Item Polaris-Connected__Item--primary"
                          >
                            <div class="Polaris-TextField">
                              <input
                                class="Polaris-TextField__Input"
                                type="text"
                                v-model="form.buttonText"
                                placeholder="Button text (e.g., Shop Now, Learn More)"
                              />
                              <div class="Polaris-TextField__Backdrop"></div>
                            </div>
                          </div>
                        </div>
                        <div class="mt-2">
                          <div class="Polaris-TextField">
                            <input
                              class="Polaris-TextField__Input"
                              type="url"
                              v-model="form.buttonUrl"
                              placeholder="Button URL (e.g., https://yourshop.com/product)"
                            />
                            <div class="Polaris-TextField__Backdrop"></div>
                          </div>
                        </div>
                        <p class="mt-2 text-sm text-gray-500">
                          Add a button with text and URL for call-to-action
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Submit Button -->
                <div class="Polaris-LegacyCard__Section">
                  <div class="flex justify-end space-x-4">
                    <button
                      type="button"
                      class="Polaris-Button Polaris-Button--pressable Polaris-Button--variantPrimary Polaris-Button--sizeMedium Polaris-Button--textAlignCenter"
                      @click="submitForm"
                      :disabled="$v.form.$invalid || buttonLoaders.isCreating"
                    >
                      <span
                        class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--medium"
                      >
                        <span v-if="buttonLoaders.isCreating">Creating...</span>
                        <span v-else>{{
                          isEditing ? "Update Upsell" : "Create Upsell"
                        }}</span>
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Right column: Preview -->
        <div>
          <div class="Polaris-LegacyCard">
            <div class="Polaris-LegacyCard__Section">
              <div
                class="Polaris-LegacyStack Polaris-LegacyStack--alignmentCenter"
              >
                <div
                  class="Polaris-LegacyStack__Item Polaris-LegacyStack__Item--fill"
                >
                  <h2 class="Polaris-Text--root Polaris-Text--headingMd">
                    Upsell Preview
                  </h2>
                  <p class="mt-1 text-sm leading-5 text-gray-500">
                    Preview your upsell message
                  </p>
                </div>
              </div>
            </div>

            <div class="Polaris-LegacyCard__Section">
              <div class="">
                <div class="mb-4">
                  <div class="space-y-2 text-sm">
                    <div class="flex">
                      <span class="text-gray-600">Name:</span>
                      <span class="font-medium text-xs ml-2">{{
                        form.name || "Not set"
                      }}</span>
                    </div>
                    <div class="flex">
                      <span class="text-gray-600">Trigger:</span>
                      <span class="font-medium text-xs ml-2">{{
                        getTriggerName(form.sendAfter) || "Not selected"
                      }}</span>
                    </div>
                    <div class="flex">
                      <span class="text-gray-600">Condition:</span>
                      <span class="font-medium text-xs ml-2">{{
                        getConditionSelectorName(form.appliesTo) ||
                        "Not selected"
                      }}</span>
                    </div>
                  </div>
                </div>

                <div class="border-t pt-4">
                  <h3 class="text-lg font-medium text-gray-900 mb-2">
                    Message Preview
                  </h3>
                  <div
                    class="bg-gray-100 rounded-lg p-4 min-h-[400px] max-w-[300px] mx-auto"
                    style="background-color: #e5ddd5"
                  >
                    <div class="flex flex-col h-full">
                      <div class="flex-grow">
                        <!-- Image Preview -->
                        <div
                          v-if="form.imageFile || form.imageUrl"
                          class="mb-3"
                        >
                          <img
                            :src="form.imagePreview || form.imageUrl"
                            alt="Upsell image"
                            class="w-full h-32 object-cover rounded-lg"
                            @error="handleImageError"
                            style="max-height: 120px"
                          />
                        </div>

                        <!-- Message Preview -->
                        <div
                          v-if="form.message"
                          class="bg-white rounded-lg p-3 text-sm inline-block max-w-[85%] shadow-sm"
                          style="border-radius: 8px 8px 8px 0"
                        >
                          <div class="whitespace-pre-wrap break-all">
                            {{ form.message }}
                          </div>
                          <!-- Button Preview -->
                          <div
                            class="text-[11px] text-gray-500 text-right mt-1"
                          >
                            11:14 AM
                          </div>
                          <div
                            v-if="form.buttonText && form.buttonUrl"
                            class="mt-3 text-center border-t-2"
                          >
                            <a
                              :href="form.buttonUrl"
                              target="_blank"
                              class="inline-block text-blue-500 px-4 py-2 rounded-lg text-sm font-medium hover:bg-[#075E54] transition-colors w-full text-center"
                            >
                              {{ form.buttonText }}
                            </a>
                          </div>
                        </div>
                        <div
                          v-else
                          class="bg-white rounded-lg p-3 text-sm inline-block max-w-[85%] text-gray-400 italic shadow-sm"
                          style="border-radius: 8px 8px 8px 0"
                        >
                          Select a template to preview your upsell message...
                          <div
                            class="text-[11px] text-gray-500 text-right mt-1"
                          >
                            11:14 AM
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="mt-4 p-3 bg-blue-50 rounded-lg">
                  <div class="flex items-start">
                    <svg
                      class="h-5 w-5 text-blue-400 mt-0.5 mr-2"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                        clip-rule="evenodd"
                      ></path>
                    </svg>
                    <div class="text-sm text-blue-700">
                      <p class="font-medium">Automated Upsell</p>
                      <p class="mt-1">
                        This upsell will automatically trigger based on your
                        configured conditions when customers meet the criteria.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <OwnNumberForm
        v-if="showOwnNumberForm"
        :feautureType="feautureType"
        @close="showOwnNumberForm = false"
      />
      <TemplateApprovalForm
        :templateType="templateApprovalType"
        v-if="showTemplateApprovalForm"
        @close="showTemplateApprovalForm = false"
      />
      <AdvancedPlanAlert
        v-if="showAdvancedPlanAlert"
        :feautureType="feautureType"
        @close="showAdvancedPlanAlert = false"
      />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { required } from "vuelidate/lib/validators";

import OwnNumberForm from "../../components/Forms/OwnNumberForm.vue";
import TemplateApprovalForm from "../../components/Forms/TemplateApprovalForm.vue";
import AdvancedPlanAlert from "../../components/Forms/AdvancedPlanAlert.vue";
import AutomationVariableDropdown from "../../components/Forms/AutomationVariableDropdown.vue";

export default {
  name: "CreateUpsell",
  components: {
    OwnNumberForm,
    TemplateApprovalForm,
    AdvancedPlanAlert,
    AutomationVariableDropdown
  },
  data() {
    return {
      isEditing: false,
      form: {
        name: "",
        sendAfter: "order_created",
        sendAfterDays: 7,
        appliesTo: "all",
        conditions: {
          products: [],
          daysWithoutPurchase: 30,
          shouldCheckForDaysWithoutPurchase: false
        },
        message: "",
        templateId: "",
        imageUrl: "",
        buttonText: "",
        buttonUrl: ""
      },
      upsell: null,
      buttonLoaders: {
        isCreating: false
      },
      availableProducts: [],
      availableTemplates: [],
      showOwnNumberForm: false,
      showTemplateApprovalForm: false,
      showAdvancedPlanAlert: false,
      feautureType: "custom_template",
      templateApprovalType: "upsell"
    };
  },
  validations: {
    form: {
      name: {
        required
      },
      sendAfter: {
        required
      },
      sendAfterDays: {
        required
      },
      appliesTo: {
        required
      },
      message: {
        required
      }
    }
  },
  computed: {
    // Computed properties for available data
  },
  mounted() {
    this.$refs.name.focus();
    this.loadAvailableData();

    // Check if we're editing an existing upsell
    if (this.$route.query.edit) {
      this.isEditing = true;
      this.loadUpsell(this.$route.query.edit);
    }
  },
  methods: {
    goBack() {
      this.$router.push({ name: "Upsells" });
    },
    async loadUpsell(id) {
      // Load existing upsell data
      // This would typically make an API call
      console.log("Loading upsell with ID:", id);

      try {
        const response = await this.$store.dispatch("Upsell/getUpsellById", {
          upsellId: id
        });

        if (response.upsell) {
          this.upsell = response.upsell;
          // Populate form with existing upsell data
          this.form = {
            name: response.upsell.name || "",
            sendAfter: response.upsell.sendAfter || "order_created",
            sendAfterDays: response.upsell.sendAfterDays || 7,
            appliesTo: response.upsell.appliesTo || "all",
            conditions: {
              products: response.upsell.conditions?.products || [],

              daysWithoutPurchase:
                response.upsell.conditions?.daysWithoutPurchase || 0,
              shouldCheckForDaysWithoutPurchase:
                response.upsell.conditions?.shouldCheckForDaysWithoutPurchase ||
                false
            },
            message: response.upsell.message || "",
            templateId: response.upsell.templateId || ""
          };
        }
      } catch (error) {
        console.error("Error loading upsell:", error);
      }
    },
    async submitForm() {
      if (!this.validateForm()) {
        return;
      }

      this.buttonLoaders.isCreating = true;

      try {
        if (this.isEditing) {
          // Update existing upsell
          await this.$store.dispatch("Upsell/updateUpsell", {
            upsellId: this.upsell.id,
            requestParams: this.form
          });
        } else {
          // Create new upsell
          const response = await this.$store.dispatch(
            "addTemplateForApproval",
            {
              requestParams: {
                type: "upsell",
                message: this.form.message,
                imageUrl: this.form.imageUrl,
                buttonText: this.form.buttonText || null,
                buttonUrl: this.form.buttonUrl || null
              }
            }
          );
          this.form.templateId = response.template.id;

          await this.$store.dispatch("Upsell/createUpsell", {
            requestParams: this.form
          });
        }

        this.buttonLoaders.isCreating = false;
        this.$router.push({ name: "Upsells" });
      } catch (error) {
        console.error("Error creating/updating upsell:", error);
        this.buttonLoaders.isCreating = false;
      }
    },
    loadAvailableData() {
      // Load available products, collections, and templates
      // This would typically make API calls
      this.loadProducts();
    },
    async loadProducts() {
      // Load available products from store
      // this.availableProducts = await this.$store.dispatch("getProducts");
    },
    getTemplateMessage(elementName) {
      const template = this.availableTemplates.find(
        (template) => template.elementName === elementName
      );
      if (template && template.variables) {
        for (const variable of template.variables) {
          template.message = template.message.replace(
            variable.variable,
            variable.replacingElement
          );
        }
      }

      return template?.message;
    },
    getTriggerName(trigger) {
      const triggerNames = {
        order_created: "Order Created",
        order_fulfilled: "Order Fulfilled",
        order_delivered: "Order Delivered"
      };
      return triggerNames[trigger] || trigger;
    },
    getConditionSelectorName(selector) {
      const selectorNames = {
        all: "All Orders",
        specific_product: "Specific Products"
      };
      return selectorNames[selector] || selector;
    },
    getTemplateName(templateId) {
      const template = this.availableTemplates.find((t) => t.id === templateId);
      return template ? template.name : "Unknown";
    },
    getTemplatePreview(templateId) {
      const template = this.availableTemplates.find((t) => t.id === templateId);
      return template
        ? template.preview || template.content
        : "Template preview not available";
    },
    validateForm() {
      if (!this.form.name.trim()) {
        alert("Please enter an upsell name");
        return false;
      }
      if (!this.form.appliesTo) {
        alert("Please select a trigger");
        return false;
      }
      if (!this.form.message) {
        alert("Please select a message template");
        return false;
      }
      return true;
    },
    sendOwnNumber(needOwnNumber) {
      const { plan } = this.$store.getters.getStore;
      if (plan != "advanced") {
        if (needOwnNumber) {
          this.feautureType = "own_number";
        }
        this.showAdvancedPlanAlert = true;
      } else {
        this.showOwnNumberForm = true;
      }
    },
    customizeMessage(approvalType) {
      const { plan } = this.$store.getters.getStore;
      if (plan != "advanced") {
        this.feautureType = "custom_template";
        this.showAdvancedPlanAlert = true;
      } else {
        if (approvalType === "upsell") {
          this.$store.dispatch("hasUsingCustomApp").then((response) => {
            if (response.hasCustomApp) {
              this.templateApprovalType = approvalType;
              this.showTemplateApprovalForm = true;
            } else {
              this.sendOwnNumber();
            }
          });
        } else {
          this.templateApprovalType = approvalType;
          this.showTemplateApprovalForm = true;
        }
      }
    },
    async openProductPicker() {
      if (!window.shopify) {
        alert("Shopify App Bridge not available");
        return;
      }
      const selected = await window.shopify.resourcePicker({
        type: "product",
        multiple: true,
        selectionIds: this.form.conditions.products.map((p) => ({
          id: p.id
        }))
      });
      if (selected) {
        this.form.conditions.products = selected.map((product) => ({
          id: product.id,
          title: product.title
        }));
      }
    },
    removeProduct(productId) {
      this.form.conditions.products = this.form.conditions.products.filter(
        (product) => product.id !== productId
      );
    },
    async uploadFile(event) {
      try {
        console.log({ event });
        this.isFileUploading = true;
        const file = event.target.files[0];

        const response = await this.$store.dispatch("Upsell/getUploadUrl", {
          requestParams: { name: file.name, type: file.type }
        });

        const options = {
          headers: {
            "Content-Type": file.type
          }
        };
        await axios.put(response.url, file, options);
        this.form.imageUrl = response.imageUrl;
        this.isFileUploading = false;
      } catch (error) {
        this.isFileUploading = false;
        console.log("error while uploading file", error);
      }
    },
    removeImage() {
      if (this.form.imagePreview) {
        URL.revokeObjectURL(this.form.imagePreview);
      }
      this.form.imageFile = null;
      this.form.imagePreview = null;
      this.form.imageUrl = null;
      if (this.$refs.imageInput) {
        this.$refs.imageInput.value = "";
      }
    },
    handleImageError(event) {
      event.target.src = "https://via.placeholder.com/150"; // Fallback image
    },
    insertAtCursor(myValue) {
      const myField = this.$refs.content;
      // Save current scroll position
      const scrollPos = myField.scrollTop;

      //IE support
      if (document.selection) {
        // Focusing may scroll, so skip if possible
        myField.focus();
        sel = document.selection.createRange(); // eslint-disable-line
        sel.text = myValue; // eslint-disable-line
      }
      //MOZILLA and others
      else if (myField.selectionStart || myField.selectionStart == "0") {
        var startPos = myField.selectionStart;
        var endPos = myField.selectionEnd;
        myField.value =
          myField.value.substring(0, startPos) +
          myValue +
          myField.value.substring(endPos, myField.value.length);
        // Don't focus to avoid scroll jump
        // myField.focus();
        // Restore cursor position without focusing
        myField.selectionStart = myField.selectionEnd =
          startPos + myValue.length;
      } else {
        myField.value += myValue;
      }

      // Restore scroll position to prevent jumping
      myField.scrollTop = scrollPos;

      this.form.message = myField.value;
    }
  }
};
</script>
